<template>
    <div>
        ...
    </div>
</template>

<script>
import { downloadDueWitSupportingDocumentsByToken } from "@/service/api/dues.api";

export default {
    name: "DueDownload",
    async created() {
        await this.downloadDueDocuments();
    },
    methods: {
        async downloadDueDocuments() {
            const accessToken = this.$route.params.dueAccessToken;

            await downloadDueWitSupportingDocumentsByToken(accessToken);
            window.close();
        }
    }
}
</script>
